<template lang="pug">
  div.e-tabs.tabs
    span(
       v-for="item, index in tabs"
       @click="onTabSelect(item)"
       :class="item.id === activedTab ? 'active' : ''"
       ) {{item.name}}
</template>

<script>
  export default {
    name: 'e-tabs',
    props: {
      tabs: {
        type: [Array],
        default: function () {
          return []
        }
      },
      value: {
        type: String,
        default: null
      }
    },
    computed: {
      activedTab () {
        if (this.value) {
          return this.value
        } else if (this.$route.query.tabView) {
          return this.$route.query.tabView
        } else if (this.tabs.length > 0) {
          return this.tabs[0].id
        }
        return null
      }
    },
    methods: {
      onTabSelect (item) {
        this.$emit('tabChanged', item)
      }
    }
  }
</script>
